<template>
  <div class="app">
    <nav class="menu">
      <div class="content">
        <img src="../assets/logo.png"/>
        <span class="name">依爱主机实操模拟</span>
        <div class="right-menu">
          <a href="/">网站首页</a>
          <a  class="selected" href="/contact">联系我们</a>
          <a href="/p">用户协议</a>
        </div>
      </div>
    </nav>
    <div class="container">
      <div class="main-wrapper index">
        <div class="main index">
          <div class="index-content">
            <div class="title">依爱主机实操模拟</div>
            <div class="sub-title">
              <span>依爱主机实操模拟全面覆盖考试内容，精心筛选真题与模拟题，提供多种学习资源，满足不同学员需求。</span>
              <span>依爱主机实操模拟采用科学练题模式，含章节练习、真题模拟等，结合智能错题本，助力精准复习。名师解析题目，揭示高频考点，确保学员掌握核心知识。</span>
              <span>依爱主机实操模拟考试必备，精选题库、名师解析，助您高效提分、轻松通关！ </span>
            </div>
          </div>
          <div class="video"><img src="../assets/video.png"/></div>
        </div>
      </div>      
      <div class="main-wrapper about">
        <div class="main">
          <h3>联系我们</h3>
          <div class="profile">
            <img src="../assets/address.png"/>
						<div class="address">
							<div class="location"><img src="../assets/location.svg"/><span>上海</span></div>
							<p>公司名称：上海爻塔科技有限公司</p>
							<p>公司地址：上海市崇明区城桥镇乔松路492号</p>
							<p>服务热线：+86 191-2197-2761</p>
							<p>邮箱地址：zayukeji2022@126.com</p>
						</div>
          </div>
        </div>
      </div>
      <div class="main-wrapper footer">
        <div class="main" style="font-weight:normal">
          Copyright &COPY; 2024 依爱主机实操模拟  <a href="https://beian.miit.gov.cn" style="color:#333;text-decoration: none;">沪ICP备2024055314号-2</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yaml from 'js-yaml'
import axios from 'axios'
export default {
  name: 'app',
  data() {
    return {
      showios: false,
      showand: false,
      download: '',
      config: '',
      text: '点击下载Windows客户端 (64位)',
      visible: false,
      cvisible: false
    };
  },
  methods: {
    showcode(key) {
      if (key === 'ios') {
        this.showios = true
      } else {
        this.showand = true
      }
    },
    hidecode(key) {
      if (key === 'ios') {
        this.showios = false
      }else{
        this.showand = false
      }
    },
    downloadClient(){
      location.href = this.download
    }
  },
  mounted() {
    // this.getPosType()
  }
};
</script>

<style lang="less" scoped>
@font-face {
	  font-family: 'Truth';
	  src: url('../assets/fonts/truth.woff') format('woff'), url('../assets/fonts/truth.otf') format('otf'), url('../assets/fonts/truth.ttf') format('opentype');
	  font-style: normal;
	  font-weight: normal;
	}
html,
body {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  width: 100%;
  /* overflow: hidden; */
  font-family: "microsoft yahei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.app {
  /* height: 100%; */
  width: 100%;
}
p {
  /* margin: 0; */
  /* text-align: center; */
  /* width: 800px; */
  margin: 0 auto;
}
h1,h3,h4,h2,h5{
  padding: 0;
  margin: 0;
}
h3{
  font-size: 32px;
  margin-bottom: 20px;
  // font-family: 'Truth';
  font-weight: 500;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}
.container{
  width: 100%;
}
.menu{
  // position: absolute;
  // left: 0;
  // right: 0;
  // top: 0;
  background: rgba(255, 255, 255, 1);
  .content{
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 15px 0;
    font-size: 24px;
    // justify-content: space-between;
    img{
      width: 48px;
      height: 48px;
      margin-right: 10px ;
      border-radius: 10px;
      border: 1px solid #F5F5F5;

    }
    .name{
      color: #333;
      font-size: 26px;
      font-weight: 700;
      font-family: 'Truth';
    }
  }
  .right-menu{
    font-size: 16px;
    color: #333;
    cursor: pointer;
    // font-weight: 500;
    margin-left: auto;
    a{
      width: 140px;
      display: inline-block;
      text-align: center;
      text-decoration: none;
			color: #333;
      &.selected{
        color: #007FFF;
        position: relative;
        &::before{
          content: '';
          position: absolute;
          width: 30px;
          height: 2px;
          background: #007FFF;
          left: 50%;
          transform: translateX(-50%);
          bottom: -5px;
          border-radius: 4px;
        }
      }
    }
  }
  .free{
    margin-right: 30px;
    color: #007FFF;
    position: relative;
    &::before{
      content: '免费';
      font-size: 6px;
      position: absolute;
      right: -20px;
      top: -15px;
      background-color: #CE5653;
      color: #fff;
      padding: 0 5px;
      border-radius: 10px;
    }
  }
}

.main{
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  /* display: inline-block; */
  &.index{
    margin-top: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: space-between;
    margin: 30px auto;
    h1{
      font-size: 48px;
    }
    h4{
      font-size: 36px;
      font-weight: 400;
      margin-top: 20px;
      margin-bottom: 50px;
    }
    .video{
      width: 405px;
      height: 420px;
      img{
        width: 405px;
      height: 420px;
      }
    }
    
  }
  &.resume{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.button-code{
  width: 190px;
  height: 50px;
  border-radius: 50px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #333;
  cursor: pointer;
  img{
    width: 20px;
    height: 22px;
    margin-right: 20px;
  }
}
.index-phone {
  display: inline-block;
  img{
    width: 264px;
    margin-right: 150px;
  }
}
.index-content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .title{
    font-size: 58px;
    font-weight: 600;
    font-family: 'Truth';
    color: #333;
    display: flex;
    align-items: flex-end;
  }
  .sub-title{
    margin-top: 20px;
    font-size: 18px;
    color: #999;
    display: flex;
    flex-direction: column;
    // align-items: flex-start;
    // justify-content: space-between;
    span{
      position: relative;
      // padding-left: 20px;
      line-height: 30px;
      text-align: left;

    }
  }
}
.buttons{
  .pc{
    display: flex;
    align-items: center;
    width: 500px;
    background: #007FFF;
    border-radius: 50px;
    justify-content: center;
    height: 44px;
    cursor: pointer;
    margin-top: 50px;
    img{
      height: 20px;
      margin-right: 10px;
    }
  }
  
}
.main-wrapper{
  width: 100%;
  display: inline-block;
  &.index{
    height: 500px;
    // background: url('../assets/bgggg.png');
    // background-size: 100% auto;
    background: linear-gradient(96deg, #FFF 3.15%, #bdd2e8 100%);
    
  }
  
  &.about{
    background: #fff;
    text-align: center;
    color: #333;
    padding: 60px 0;
    .profile{
      margin: 40px 0;
			display: flex;
			align-items: center;
			border-radius: 8px;
			border: 1px solid var(---, #E5E7EB);
			padding: 12px;
			img{
				margin-right: 60px;
			}
			.address{
				display: flex;
				flex-direction: column;
				text-align: left;
				.location{
					margin-bottom: 64px;
					display: flex;
					align-items: center;
					font-size: 24px;
					font-weight: 500;
					img{
						width: 36px;
						margin-right: 12px;
					}
				}
			}
      p{
        text-align: left;
        line-height: 2.5;
        font-size: 14px;
        color: #666;
				margin: 0;
      }
    }
  }
  &.footer{
    background: #fff;
    padding: 32px 0;
    text-align: center;
    color: #333;
		border-top: 1px solid #EFEFEF;
  }
}
.popup{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  .p-body{
    position: absolute;
    width: 600px;
    height: 500px;
    background: #fff;
    color: #333;
    box-sizing: border-box;
    padding: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .p-title{
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    span{
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 30px;
      font-weight: 100;
      cursor: pointer;
      padding: 0 5px;
    }
  }
  p{
    line-height: 2;
    &.q{
      font-weight: 500;
      margin: 10px 0;
    }
    &.a{
      color: #666;

      font-size: 14px;
    }
  }
}
.items{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 50px;
  .item{
    width: 254px;
    text-align: center;
    display: flex;
    height: 182px;
    overflow: hidden;
    margin-bottom: 60px;
    img{
      width: 100%;
      height: 182px;
    }
    &:last-child{
      width: 569px;
    }
  }
}
.mutil{
  // margin-top: 80px;
  padding: 40px 0;
  // background: linear-gradient(90deg, rgba(29, 97, 232,0.3), rgba(211, 230, 252,0.3));
  color: #333;
  // background: url('../assets/mutilbg.png') no-repeat;
  // background-size: 100% auto;
}
.hezuo{
  color: #333;
  margin-top: 80px;
  margin-bottom: 80px;
  span{
    color: #CE5653;
  }
  .lists{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 40px;
    div{
      width: 240px;
      height: 240px;
      background: #fcfcfc;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #f4f4f4;
      border-bottom: 1px solid #f4f4f4;
      box-sizing: border-box;
      &:hover{
        background: rgba(55, 111, 246, 0.3);
      }
    }
    img{
      width: 120px;
      height: 120px;
      border-radius: 120px;
    }
  }
}
.color{
  color:#CE5653 ;
}
@media screen and (max-width: 768px) {
  .menu{
    .content{
      padding: 15px 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .right-menu{
      display: none;
    }
  }
  .index-content{
    .title{
      font-size: 30px;
      // flex-direction: column;
      align-items: flex-end;
      div{      
        span:first-child{
          color: #CE5653;
          font-family: 'Truth';
          font-size: 30px;
        }
      }
      .subfix{
        // margin-left: 0;
        font-size: 17px;
        // margin-top: 10px;
      }
    }
  }
  .sub-title{
    .pc,.phone{
      display: none;
    }
    span::before{
      top:8px !important;
      margin-top: 0 !important;
    }
  }
  .h5{
      display: inline-block !important;
      margin-bottom: 5px;
    }
  .buttons{
    display: none;
  }
  .main.index{
    flex-direction: column;
    width: 100%;
    margin-top: 100px;
    box-sizing: border-box;
    padding: 0 20px;
    justify-content: center;
    .video {
      width: 100%;
      height: auto;
      margin-top: 40px;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .main-wrapper.index{
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 520px;
    .app{
      display: none;
    }
  }
  .main-wrapper.jobs{
    display: none;
  }
  .main{
    width: 100%;
  }
  .hezuo{
    margin-top: 40px;
    margin-bottom: 40px;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .hezuo .lists{
    width:100%;
    justify-content: center;
    div{
      width: 50%;
    }
  }
  .main-wrapper.demo {
    .lists{
      box-sizing: border-box;
      padding: 0 20px;
      .item{
        margin-bottom: 20px;
      }
      img{
        width:100%;
        height: auto;
      }
    }
  }
  .main-wrapper.footer{
    font-size: 14px;
  }
  .mutil{
    background-size: auto 100%;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  h3{
    font-size: 28px;
  }
  p,span{
    text-align: left;
  }
}
</style>
